



































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { AdcontrolProfile, User } from "@/models";
import { Getter, Action } from "vuex-class";
import MatchProductPrincipalAccordion from "@/components/Agents/MatchProductPrincipalAccordion.vue";
import { AgentModuleConfiguration } from "@/models";
import AgentModuleConfigurationMixin, {
  AgentModuleConfigurationMixinTags,
} from "@/mixins/http/Agencies/AgentModuleConfigurationMixin";
import Product, { AgentProductMixinTags } from "@/mixins/http/Agents/Product";
import {
  FEATURE_AGENTS_MATCH_BY_PRODUCT,
  FEATURE_AGENTS_MULTIPLE_PRODUCTS,
} from "@/constants";
import SelectOption from "@/interfaces/SelectOption";
import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import { MissingPrincipalProductCompany } from "@/models/Agents/Product";
import MatchMultipleProductSelectPrincipalAccordion from "@/components/Agents/MatchMultipleProductSelectPrincipalAccordion.vue";
import ToastInvoker from "@/utils/ToastInvoker";
import MessagePanel from "@/components/MessagePanel.vue";

@Component({
  components: {
    MessagePanel,
    VMultiSwitcher,
    MatchProductPrincipalAccordion,
    MatchMultipleProductSelectPrincipalAccordion,
  },
})
export default class DuplicatedProductsManagement extends Mixins(
  Product,
  AgentModuleConfigurationMixin
) {
  @Getter("profile") readonly profile!: AdcontrolProfile;
  @Getter("user") readonly user!: User;

  @Action("notificationsGroups/valorizeProducts")
  readonly valorizeProductsNotifications!: (notificationCount: number) => void;
  @Action("notificationsGroups/valorizeMultipleProducts")
  readonly valorizeMultipleProductsNotifications!: (
    notificationCount: number
  ) => void;

  private modelItems: Array<SelectOption> = [
    { id: "products", text: "CAPOFILA MANCANTI DEI PRODOTTI" },
    { id: "multiple_products", text: "PRODOTTI MULTIPLI" },
  ];

  productsWithMissingPrincipalCompanies: MissingPrincipalProductCompany[] = [];
  agentModuleConfiguration: AgentModuleConfiguration | null = null;
  selectedModel = "products";
  multipleProductsGroupsNames: string[] = [];

  async mounted() {
    await this.valorizeProducts();
    await this.valorizeAgentModuleConfiguration();
  }

  @Watch("selectedModel")
  async onSelectedModelChange() {
    if (this.selectedModel === "multiple_products") {
      await this.valorizeMultipleProducts();
    } else {
      await this.valorizeProducts();
    }
  }

  get loading(): boolean {
    const productsLoading =
      this.$store.getters["http/status"][
        AgentProductMixinTags.GetProductsWithoutPrincipals
      ]?.loading ?? false;

    const multipleProductsLoading =
      this.$store.getters["http/status"][
        AgentProductMixinTags.GetMultipleProductsGroupsNames
      ]?.loading ?? false;

    const agentModuleConfigurationLoading =
      this.$store.getters["http/status"][
        AgentModuleConfigurationMixinTags.GetAgentModuleConfiguration
      ]?.loading ?? false;

    return (
      productsLoading ||
      multipleProductsLoading ||
      agentModuleConfigurationLoading
    );
  }

  async valorizeMultipleProducts() {
    if (!this.hasMultipleProducts) {
      return;
    }

    try {
      this.multipleProductsGroupsNames = [];
      this.multipleProductsGroupsNames =
        await this.getMultipleProductsGroupsNames(
          AgentProductMixinTags.GetMultipleProductsGroupsNames,
          this.profile.slug
        ).then((results) => results.sort((a, b) => a.localeCompare(b))); // alphabetical sort

      this.valorizeMultipleProductsNotifications(
        this.multipleProductsGroupsNames.length
      );
    } catch (_e) {
      ToastInvoker.errorToast("Errore nel caricamento", _e);
      this.multipleProductsGroupsNames = [];
    }
  }

  async valorizeProducts() {
    if (!this.hasMatchProduct) {
      return;
    }

    try {
      this.productsWithMissingPrincipalCompanies = [];

      await this.getProductsWithoutPrincipals(
        AgentProductMixinTags.GetProductsWithoutPrincipals,
        this.profile.slug,
        {
          "page[size]": "all",
          include: "*.principal_agent_company",
        }
      )
        .then((results) => {
          return results.map((product) => {
            return {
              companyId: product.principalAgentCompany?.id || "",
              companyName: product.principalAgentCompany?.name || "",
            } as MissingPrincipalProductCompany;
          });
        })
        .then((companies) => {
          const companyMap = new Map<string, MissingPrincipalProductCompany>();

          for (const company of companies) {
            if (!companyMap.has(company.companyId)) {
              companyMap.set(company.companyId, {
                companyId: company.companyId,
                companyName: company.companyName,
              });
            }
          }
          this.productsWithMissingPrincipalCompanies = Array.from(
            companyMap.values()
          ).sort((a: any, b: any) =>
            a.companyName.localeCompare(b.companyName)
          );
        });

      this.valorizeProductsNotifications(
        this.productsWithMissingPrincipalCompanies.length
      );
    } catch (_e) {
      this.productsWithMissingPrincipalCompanies = [];
    }
  }

  async valorizeAgentModuleConfiguration() {
    try {
      this.agentModuleConfiguration = await this.getAgentModuleConfiguration(
        AgentModuleConfigurationMixinTags.GetAgentModuleConfiguration,
        this.profile.slug
      );
    } catch (_e) {
      this.agentModuleConfiguration = null;
    }
  }

  get hasMatchProduct() {
    return (
      this.user.profile?.hasFeature(FEATURE_AGENTS_MATCH_BY_PRODUCT) ?? false
    );
  }

  get hasMultipleProducts() {
    return (
      this.user.profile?.hasFeature(FEATURE_AGENTS_MULTIPLE_PRODUCTS) ?? false
    );
  }

  get productsSelectedModel() {
    return this.selectedModel === "products";
  }

  get multipleProductsSelectedModel() {
    return this.selectedModel === "multiple_products";
  }
}
